<template>
  <a
    href="javascript:;"
    data-reason="index"
    data-type="playVideo"
    class="video-play limit-px ib"
    @click="showYoutubeVideo(websiteConfig.index.videoLink); clickBtnUpload($event)"
    v-if="websiteConfig.index.videoLink && websiteConfig.index.videoLink.length"
  >
    <span class="play-icon limit-px"></span>
    <span class="rotate-circle limit-px"></span>
  </a>
</template>

<script lang="ts" setup>
import popupHook from '@/hooks/popupHook';
const { showPopup, showYoutubeVideo } = popupHook();
import { clickBtnUpload } from '@/utils/pointUtils';
import websiteConfig from '@/configs/websiteConfig';
</script>
